import LockIcon from "@mui/icons-material/Lock";

import { ApprovalMode } from "@/shared/domain/chat/clientTools/approvalModes";

import styles from "./ClientToolSettingsModal.module.css";

const SEGMENTS: { mode: ApprovalMode; label: string }[] = [
  { mode: ApprovalMode.REQUIRE_APPROVAL, label: "Ask First" },
  { mode: ApprovalMode.FOLLOW_AUTO, label: "Auto" },
  { mode: ApprovalMode.AUTO_EXECUTE, label: "Always Run" },
];

interface ToolApprovalModeSelectorProps {
  selectedMode: ApprovalMode;
  allowableModes: ApprovalMode[];
  onChange: (mode: ApprovalMode) => void;
}

/**
 * 3-way segmented control for selecting a tool's approval mode.
 *
 * Segments not in `allowableModes` are visually disabled with a lock
 * icon and are not selectable.
 */
export function ToolApprovalModeSelector({
  selectedMode,
  allowableModes,
  onChange,
}: ToolApprovalModeSelectorProps) {
  return (
    <div className={styles.segmentedControl}>
      {SEGMENTS.map(({ mode, label }) => {
        const isAllowed = allowableModes.includes(mode);
        const isSelected = mode === selectedMode;

        return (
          <button
            key={mode}
            type="button"
            className={`${styles.segment} ${isSelected ? styles.segmentSelected : ""} ${!isAllowed ? styles.segmentLocked : ""}`}
            disabled={!isAllowed}
            onClick={() => {
              if (isAllowed) {
                onChange(mode);
              }
            }}
            aria-pressed={isSelected}
          >
            {label}
            {!isAllowed && <LockIcon className={styles.lockIcon} />}
          </button>
        );
      })}
    </div>
  );
}
